export const actionTypes = {
    SET_PINNED_IDS: "PINNED:SET_IDS",
    SET_PINNED_USERS: "PINNED:SET_USERS",
    SET_PINNED_USERS_BY_PAGE: "PINNED:SET_USERS_BY_PAGE",
    SET_PINNED_LOADING: "PINNED:SET_PINNED_LOADING",
    RESET_PINNED: "PINNED:RESET",
};